import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {PlanService} from '../../../services/plan.service';
import * as fromStore from '../../../store';
import {Store} from '@ngrx/store';
import * as featureActions from '../../index';
import {updateInfoType} from '../../../shareModel';
import {UpdateInfoModel} from '../../updateInfo/update-info.model';
import {catchError, concatMap, map, switchMap, withLatestFrom} from 'rxjs/operators';
import {EMPTY, of} from 'rxjs';
import {PlanSettingActions, PlanSettingActionTypes} from '../../index';
import {PlanSetting, PlanSettingModel, PlanSettingParams} from '../plan-setting.model';
import {ActivatePlanKey} from '../../index';


@Injectable()
export class PlanSettingsEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private planService = inject(PlanService);

  constructor() {}

  GetPlanSettings$ = createEffect(() => this.actions$.pipe(
     ofType(PlanSettingActionTypes.GetPlanSettings),
     withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
     switchMap(([payload, user]) => {
       const params = {
         otp: user.otp,
         acode: user.acode
       };
       return this.planService.ReadPlanSetting(params).pipe(
         switchMap((res: any) => {
           if (res.result && res.msg.body && Array.isArray(res.msg.body)) {
               return [new featureActions.LoadPlanSettings({ planSettings: res.msg.body})];
           }
           throw new Error('update fail');
         }), catchError(error => {
           return of(new featureActions.GetPlanSettingsFail());
         })
       );
     })
   ));
  GetUpdatePlanSettings$ = createEffect(() => this.actions$.pipe(
     ofType(PlanSettingActionTypes.GetUpdatePlanSettings),
     map((action: featureActions.GetUpdatePlanSettings) => action.payload),
     withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
     switchMap(([payload, user]) => {
       const params: PlanSettingParams = {
         PlanInfoId: payload.PlanInfoId,
         dcodes: Array.isArray(payload.dcodes) ? [...payload.dcodes] : payload.dcodes,
         otp: user.otp
       };
       return this.planService.UpdatePlanSetting(params).pipe(
         switchMap((res: any) => {
           const result = { ...res, type: updateInfoType.UpdatePlanSetting };
           if (result.result) {
            const moduleParam = {isLoadPlan: true, force: true};
             return [new featureActions.GetPlanSettings(),
                     new fromStore.GetUserModules(moduleParam),
                     new featureActions.UpdateInfoSuccessAction(result)];
           }
           throw new Error('update fail');
         }),
         // TODO: catchError Message調整 --> 已完成
         catchError(error => {
           const res: UpdateInfoModel = {
             result: false,
             errmsg: 'Error',
             type: updateInfoType.UpdatePlanSetting
           };
           return [new featureActions.GetPlanSettingsFail(), new featureActions.UpdateInfoFailAction(res)];
         })
       );
     })
   ));
  ActivatePlanKey$ = createEffect(() => this.actions$.pipe(
     ofType(PlanSettingActionTypes.ActivatePlanKey),
     map((action: featureActions.ActivatePlanKey) => action.payload),
     withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
     switchMap(([payload, user]) => {
       const params = {
         otp: user.otp,
         KeyNumber: payload
       };
       return this.planService.ActivatePlanKey(params).pipe(
         switchMap((res: any) => {
           if (res.result) {
             const result = { ...res, type: updateInfoType.ActivatePlanKey };
             return [new featureActions.GetPlanSettings(), new featureActions.UpdateInfoSuccessAction(result)];
           }
           throw new Error('update error');
         }),
         // TODO: catchError Message調整 --> 已完成
         catchError(error => {
           const res: UpdateInfoModel = {
             result: false,
             errmsg: 'Error',
             type: updateInfoType.ActivatePlanKey
           };
           return of(new featureActions.UpdateInfoFailAction(res));
         })
       );
     })
   ));

}
